exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loadingIndicator {\n  text-align: center;\n  margin: 2em 0; }\n  .loadingIndicator.verticalCenter {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    -webkit-transform: translate(-50%, -50%); }\n  .loadingIndicator .initText {\n    display: block;\n    margin-top: 0.6em;\n    color: #cc6800;\n    font-weight: 500;\n    font-size: 16px; }\n", ""]);

// exports
